import TwitchLogo from "../assets/TwitchLogo.png";
import KickLogo from "../assets/Kicklogo.png";
import TikTokLogo from "../assets/TikTokLogo.png"
import TwitterXLogo from "../assets/Twitter-XLogo.jpg";
import InstagramLogo from "../assets/InstagramLogo.png";
import YoutubeLogo from "../assets/youtube.png";
import GitHubLogo from "../assets/GithubLogo.png";
import GiteaLogo from "../assets/gitealogo.png";
 
export const SocialList = [
    {
        hiddenLink: <a href="https://www.twitch.tv/ehchad" target="_blank" />,
        name: "Twitch",
        image: TwitchLogo,
        link: <a href="https://www.twitch.tv/ehchad" target="_blank">Check Out My Twitch!</a>
    },

    {
        hiddenLink: <a href="https://kick.com/ehchad" target="_blank" />,
        name: "Kick",
        image: KickLogo,
        link: <a href="https://kick.com/ehchad" target="_blank">Check Out My Kick!</a>
    },

    {
        hiddenLink: <a href="https://www.tiktok.com/@eh_chad" target="_blank" />,
        name: "TikTok",
        image: TikTokLogo,
        link: <a href="https://www.tiktok.com/@eh_chad" target="_blank">Check Out My TikTok!</a>
    },

    {
        hiddenLink: <a href="https://x.com/EhChad_real" target="_blank" />,
        name: "Twitter-X",
        image: TwitterXLogo,
        link: <a href="https://x.com/EhChad_real" target="_blank">Check Out My Twitter-X!</a>
    },

    {
        hiddenLink: <a href="https://www.instagram.com/chad.doty/" target="_blank" />,
        name: "Instagram",
        image: InstagramLogo,
        link: <a href="https://www.instagram.com/chad.doty/" target="_blank">Check Out My Instagram!</a>
    },

    {
        hiddenLink: <a href="https://www.youtube.com/channel/UC3H33ordT_-qpMjUvY95ILg" target="_blank" />,
        name: "Youtube",
        image: YoutubeLogo,
        link: <a href="https://www.youtube.com/channel/UC3H33ordT_-qpMjUvY95ILg" target="_blank">Check Out My YouTube!</a>
    },

    {
        hiddenLink: <a href="https://github.com/DevEhChad" target="_blank" />,
        name: "GitHub",
        image: GitHubLogo,
        link: <a href="https://github.com/DevEhChad" target="_blank">Check Out My GitHub!</a>
    },

    {
        hiddenLink: <a href="https://gitea.ecsgameservers.com/chad" target="_blank" />,
        name: "Gitea (Self Hosted)",
        image: GiteaLogo,
        link: <a href="https://gitea.ecsgameservers.com/chad" target="_blank">Check Out My Gitea!</a>
    }
];